import React from "react";
import { AggregatedPeriodicReport } from "../../../containers";

const AggregatedReport = (props) => {
  return <AggregatedPeriodicReport {...props} />;
};

export default AggregatedReport;
